<template>
  <div class="container-tag" :class="(state === 1) ? 'active' : 'inactive'">
    <span class="cicle" :class="(state === 1) ? 'circle-active' : 'circle-inactive'" />
    <h1>{{ data }}</h1>
  </div>
</template>

<script>
export default {
	props: {
		state: {
			type: Number,
			default: 0,
		},
		data: {
			type: String,
			default: '',
		},
		align: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">

.container-tag {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 2px 10px 2px 10px;
  justify-content: center;
  justify-self: center;
  font-size: 12px;
  max-width: 90px;
  cursor: pointer;
  align-self: center;
}

.cicle {
  margin-top: 1px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: 2px;
  margin-right: 3px;
}

.inactive {
  background-color:rgba(255, 159, 67,.15);
  color: #ff9f43;
}
.active {
  background-color: #cdffcd;
  color: #007f00;
}

.circle-active {
 background-color: #007f00;
}
.circle-inactive {
 background-color: #ff9f43;
}

</style>
